module.exports = __webpack_public_path__ + "img/ImagenOfertasDeEmpleo.4276afda.svg";